var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "text-shape-wrapper" },
    [
      _c(_setup.ElementLibrarySelector, {
        attrs: {
          disabled: _setup.disabled,
          "element-list": _setup.model.shapeMap,
          "library-id": _setup.model.shapeLibraryId,
          "library-type": _setup.IMAGE_TYPE,
          "selected-position": _setup.model.shapeOption,
          "element-list-position": 3,
          "library-pick-types": _setup.SHAPE_LIBRARY_TYPES,
          "option-wording": "shape",
          "external-image-picker": "",
        },
        on: {
          "open-image-picker": _setup.openPicker,
          "load-option": _setup.updateOptionSelected,
          "options-reordered": _setup.onImageOptionsReordered,
          "remove-map-option": _setup.removeImageOptionFromMap,
          "remove-library": _setup.removeImageLibrary,
          "pick-library": _setup.onPickLibrary,
        },
      }),
      _vm._v(" "),
      _setup.model.picker.open
        ? _c(_setup.MaskSelectorModal, {
            attrs: {
              type: _setup.TEXT_SHAPE_TYPE,
              multiple: !_setup.model.picker.positionToEdit,
            },
            on: {
              select: function ($event) {
                return _setup.onShapesPicked([$event])
              },
              "select-multiple": _setup.onShapesPicked,
              cancel: _setup.closePicker,
              error: function ($event) {
                return _setup.toaster.error($event)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }